// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\nimg[data-v-04013d2a] {\n    width: 2.5em;\n}\n.extra-small[data-v-04013d2a] {\n    width: 1.5em;\n}\n.small[data-v-04013d2a] {\n    width: 2em;\n}\n.medium[data-v-04013d2a] {\n    width: 2.5;\n}\n.large[data-v-04013d2a] {\n    width: 3.5;\n}\n.extra-large[data-v-04013d2a] {\n    width: 4;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
